
    import '/mnt/src/components/Divider/index.md?watch=parent';
    export const demoIndex = {
  ids: ["divider-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Divider/index.md?type=demo')
};